class PrintHelper {
    public static GetAttachmentPreviewPath(id: string): string {
        return apiSettings.buildAppUrl(`api/attachments/download/${id}`, { auth: true });
    }

    public static ShowAttachmentPreview(id: string): void {
        this.ShowPrintPreview(this.GetAttachmentPreviewPath(id));
    }

    public static GetPreviewPath(fileName: string): string {
        return apiSettings.buildAppUrl(`api/pdf/fetch/${fileName}`, { auth: true, noCache: true });
    }

    public static ShowPrintPreviewFileName(fileName: string): void {
        if (!fileName)
            return;

        this.ShowPrintPreview(this.GetPreviewPath(fileName));
    }

    public static ShowPrintPreview(pdfUrl: string): void {
        const isBrowserCompatible = navigator.userAgent.includes("Chrome")
            || navigator.userAgent.includes("Edge")
            || navigator.userAgent.includes("Mozilla");

        const isSameDomain = apiSettings.BaseUrl.includes(window.location.host);

        if (isBrowserCompatible && isSameDomain) {
            // tested on Edge, Firefox and Chrome
            // does not support cross domain (i.e. webpack dev server without proxy)
            this.ShowRealPrintPreview(pdfUrl, 150);
        }
        else {
            this.OpenPrintTab(pdfUrl);
        }
    }

    public static ShowRealPrintPreview(pdfPath: string, timeout: number = 100): void {
        pdfPath = pdfPath.replace(/\/+/g, "/").replace(/^(https?:)\//, "$1//"); // replace // with /

        const iFrame = document.createElement("iframe") as HTMLIFrameElement;
        let oldPrintFrame = document.getElementById("printFrame");

        if (oldPrintFrame != null && typeof oldPrintFrame !== "undefined") {
            oldPrintFrame.parentElement.removeChild(oldPrintFrame);
            oldPrintFrame = null;
        }

        iFrame.id = "printFrame";
        iFrame.style.visibility = "hidden";
        iFrame.style.position = "fixed";
        iFrame.style.right = "0";
        iFrame.style.bottom = "0";
        iFrame.src = pdfPath;
        document.body.appendChild(iFrame);

        iFrame.onload = () => {
            window.setTimeout(() => {
                iFrame.focus();
                iFrame.contentWindow.print();
            }, timeout);
        };

        iFrame.contentWindow.onafterprint = () => {
            document.getElementById("printFrame").remove();
        };
    }

    public static OpenPrintWindow(pdfPath: string, timeout: number = 100, width: number = 850, height: number = 600, screenX: number = 50, screenY: number = 50): void {
        let params = "dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,resizable,screenX=" + screenX + ",screenY=" + screenY + ",width=" + width + ",height=" + height;
        let doc = window.open(pdfPath, "_blank", params);

        window.setTimeout(() => doc.print(), timeout);
    }

    public static OpenPrintTab(pdfPath: string): void {
        if (pdfPath)
            window.open(pdfPath, "_blank");
    }
}

export { PrintHelper };
